import React from 'react';
import { ArrayFieldTemplateProps } from '@rjsf/core';
import { Box, Flex } from 'components/layout';
import { Button } from 'components/form-elements/buttons';
import * as Icons from 'components/icons';

export function ArrayFieldTemplate(props: ArrayFieldTemplateProps) {
  const { items, uiSchema, disabled } = props;
  const uiOptions = uiSchema?.['ui:options'] || {};
  const removable = uiOptions.removable !== false;

  return (
    <Box>
      {items.map((element, index) => (
        <Box
          key={element.key}
          sx={{
            p: 4,
            mb: 5,
            border: '1px solid #d0d0d0',
            borderRadius: '8px',
            backgroundColor: 'white',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
          }}
        >
          <Flex
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 4,
            }}
          >
            <Box
              sx={{
                fontWeight: 600,
                fontSize: 'lg',
                color: 'grey.700',
              }}
            >
              #{index + 1}
            </Box>
            {removable && items.length > 1 && !disabled && (
              <Button
                variant="secondary"
                onClick={element.onDropIndexClick(index)}
                type="button"
                prependIcon={<Icons.Delete />}
                sx={{ py: 2, px: 3, backgroundColor: 'red', width: 'auto' }}
                intlId="generic.remove"
              />
            )}
          </Flex>
          {element.children}
        </Box>
      ))}
    </Box>
  );
}
